import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http'
import {environment} from '../../environments/environment';
import {Observable, BehaviorSubject} from "rxjs";
import {map} from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    Header: HttpHeaders;
    api = environment.apiEndpoint

    constructor(private httpclient: HttpClient) {
        this.Header = new HttpHeaders();
        this.Header.append('Content-Type', 'applicaton/json');
    }

    signin(data): Observable<any> {
        return this.httpclient.post(this.api + "auth/login", data).pipe(map((data) => {
            let singindata = data
            console.log(singindata)
            return singindata;
        }))
    }

    isLoggedIn() {
        if (localStorage.getItem('auth-token')) {
            return true;
        } else {
            return false;
        }

    }

    autoLogin(id) {
        return this.httpclient.post(this.api + "auth/autologin?id=" + id, '').pipe(map((data) => {
            let singindata = data
            console.log(singindata)
            return singindata;
        }))
    }

    pendingMfaToken: string | null = null;

    mfaSetup(): Observable<any> {
        const headers = new HttpHeaders({ 'X-MFA-Token': this.pendingMfaToken || '' });
        return this.httpclient.post(this.api + 'auth/mfa/setup', {}, { headers });
    }

    verifyMfa(code: string): Observable<any> {
        const headers = new HttpHeaders({ 'X-MFA-Token': this.pendingMfaToken || '' });
        return this.httpclient.post(this.api + 'auth/mfa/verify', { code }, { headers });
    }

    completeLogin(res: { token: any, user_slug: any, tutor_ornot: any }): void {
        localStorage.setItem('auth-token', res.token);
        localStorage.setItem('user_slug', res.user_slug);
        localStorage.setItem('tutor_ornot', res.tutor_ornot);
        this.pendingMfaToken = null;
        this.hideshowheader(true);
    }

    tophideheader = new BehaviorSubject(false);

    hideshowheader(showhideheader) {
        this.tophideheader.next(showhideheader);
    }

}

